import api from '@/api';

import { API_BASE_URL } from '../../index';
import {
  ReportInventoryRegisterBookParms,
  ReportPurchaseParams,
} from './ReportPurchase.types';

const baseUrl = API_BASE_URL;

export async function generateInventoryRegisterBook(
  params: ReportInventoryRegisterBookParms,
) {
  const result = (await api.getReport(
    `${baseUrl}/generate/inventory-register-book`,
    params,
  )) as unknown;

  return result as BlobPart;
}

export async function generatePurchaseReport(params: ReportPurchaseParams) {
  const result = (await api.getReport(
    `${baseUrl}/generate/purchases-releases`,
    params,
  )) as unknown;

  return result as BlobPart;
}

export async function generatePurchaseReportArrayBuffer(
  params: ReportPurchaseParams,
) {
  const result = (await api.getReport(
    `${baseUrl}/generate/purchases-releases`,
    params,
    {
      responseEncoding: 'binary',
      headers: {
        'Content-type': 'application/pdf',
      },
    },
  )) as unknown;

  return result as ArrayBuffer;
}
